// extracted by mini-css-extract-plugin
export var center = "_s-2";
export var clickableRow = "_s-5";
export var expandedRow = "_s-7";
export var hoverable = "_s-4";
export var left = "_s-1";
export var right = "_s-3";
export var row = "_s-0";
export var selectedRow = "_s-6";
export var summaryRow = "_s-8";